import React from 'react';
import '../App.css'
import Header from '../Components/header.js'
import { employment } from '../data/employment.js'
import { education } from '../data/education_data.js'
import { city_images } from '../data/images.js'
import Navigator from '../Components/navigator.js'
import Experience from '../Components/experience'
import Education from '../Components/education'
import LeafletMap from '../Components/leaflet-map';
import CarouselModal from '../Components/carousel-modal';
import Recipes from '../Components/recipes.js';
import APIService from '../Services/APIService'


class Home extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        current_section: "map",
        show_carousel: false,
        images: []
      }
      this.change_state = this.change_state.bind(this)
      this.show_photos = this.show_photos.bind(this)
      this.handle_close_carousel = this.handle_close_carousel.bind(this)
      this.reset_page = this.reset_page.bind(this)
    }
    
    reset_page () {
      this.setState({
        current_section: "",
        show_carousel: false,
        images: [],
        no_pics: false
      })
    }

    change_state (section) {
      this.setState({
        current_section: section
      })
    }
    
    print_state () {
      console.log(this.state)
    }

    show_carousel () {
      this.setState({
        show_carousel: true
      })
    }

    handle_close_carousel () {
      this.setState({
        show_carousel: false
      })
    }

    show_photos (city) {
      APIService.getImages(city.replace(' ','+')).then(response => {
          let imageSet
          console.log("api response.data");
          console.log(response.data);
          if(response.status === 200) {
            console.log("response 200");
            imageSet = response.data
            if (imageSet.length > 0) {
              this.setState({
                images:imageSet,
                show_carousel: true,
                current_city: city,
                no_pics: false
              })
            }else {
              console.log('no images for this city else')
              imageSet = city_images['Georgia']
    
              this.setState({
                images:imageSet,
                show_carousel: true,
                current_city: city,
                no_pics: true
              })
            }
          } else if(response.status === 515) {
            console.log("response 515");
            imageSet = city_images['Georgia']
    
            this.setState({
              images:imageSet,
              show_carousel: true,
              current_city: city,
              no_pics: true
            })
          }
      }).catch(e => {
          console.log("error in api call")
          console.log(e);
          let  imageSet = city_images['Georgia']
    
              this.setState({
                images:imageSet,
                show_carousel: true,
                current_city: city,
                no_pics: true
              })
      });
    }

    render() {
      return (
        
          <div>
              <Header reset_page={this.reset_page}></Header>
              <Navigator change_state={this.change_state} current_state={this.state.current_section}></Navigator>
              {this.state.current_section === "experience" &&
                <Experience id="experience" data={employment} ish="ish"></Experience>
              }
              {this.state.current_section === "education" &&
                <Education id="education" data={education} ish="ish"></Education>
              }
              {this.state.current_section === "recipes" &&

                <Recipes />

              }
              {this.state.current_section === "map" &&

              <LeafletMap legendData={this.state.legendData} show_photos={this.show_photos} show_carousel={this.show_carousel}></LeafletMap>

              }
              <CarouselModal no_pics={this.state.no_pics} city={this.state.current_city} handle_close_carousel={this.handle_close_carousel} show={this.state.show_carousel} images={this.state.images}></CarouselModal>
              <div className="row justify-content-center">
              </div>
          </div>
  
      );
    };
  }
  
  export default Home;
    